var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyTreeDnaa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round"
    },
    viewBox: "0 0 2257 2260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M202.464 0c111.818 0 202.465 91.055 202.465 203.376s-90.647 203.377-202.465 203.377S0 315.7 0 203.376C0 91.052 90.646 0 202.464 0Z",
    style: {
      fill: "#d8eef2",
      fillOpacity: 0.29,
      fillRule: "nonzero"
    },
    transform: "translate(6.656) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.67 0c95.273 0 173.67 78.397 173.67 173.67 0 95.273-78.397 173.67-173.67 173.67C78.397 347.34 0 268.943 0 173.67 0 78.397 78.397 0 173.67 0Z",
    style: {
      fill: "#f4f8ff",
      fillRule: "nonzero"
    },
    transform: "translate(165.106 157.067) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.285 31.528C-36.168 104.9 72.028 183.064 223.555 0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#043e59",
      strokeOpacity: 0,
      strokeWidth: 1
    },
    transform: "scale(5.55556) rotate(3 -3836.828 363.942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.606 206.722h188.172",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#747683",
      strokeWidth: 3,
      strokeLinecap: "butt"
    },
    transform: "translate(-358.028 452.306) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.606 206.722h164.035",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#747683",
      strokeWidth: 3,
      strokeLinecap: "butt"
    },
    transform: "translate(-845.656 -389.428) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h91.737",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#747683",
      strokeWidth: 3,
      strokeLinecap: "butt"
    },
    transform: "rotate(90 303.378 1394.49) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h91.737",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#747683",
      strokeWidth: 3,
      strokeLinecap: "butt"
    },
    transform: "rotate(90 -296.85 462.178) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.824 102.044v17.643H161.879v-17.643",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#747683",
      strokeWidth: 3,
      strokeLinecap: "butt"
    },
    transform: "translate(431.023 420.384) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h76.262",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#747683",
      strokeWidth: 3,
      strokeLinecap: "butt"
    },
    transform: "rotate(-90 859.256 -100.233) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.614 114.227c-7.643 0-15.058-1.496-22.037-4.448a56.642 56.642 0 0 1-9.616-5.22 56.994 56.994 0 0 1-8.379-6.913 57.072 57.072 0 0 1-6.914-8.38 56.529 56.529 0 0 1-5.219-9.616C2.497 72.671 1 65.257 1 57.614c0-7.644 1.497-15.058 4.449-22.037a56.567 56.567 0 0 1 5.219-9.616 57.064 57.064 0 0 1 6.914-8.379 57.064 57.064 0 0 1 8.379-6.914 56.567 56.567 0 0 1 9.616-5.219C42.556 2.497 49.971 1 57.614 1c7.643 0 15.057 1.497 22.036 4.449a56.49 56.49 0 0 1 9.616 5.219 57.072 57.072 0 0 1 8.38 6.914 56.994 56.994 0 0 1 6.913 8.379 56.642 56.642 0 0 1 5.22 9.616c2.952 6.979 4.449 14.393 4.449 22.037 0 7.643-1.497 15.057-4.449 22.036a56.604 56.604 0 0 1-5.22 9.616 57.002 57.002 0 0 1-6.913 8.38 57.002 57.002 0 0 1-8.38 6.913 56.566 56.566 0 0 1-9.616 5.22c-6.979 2.952-14.393 4.448-22.036 4.448Z",
    style: {
      fill: "#0279cf",
      fillRule: "nonzero"
    },
    transform: "translate(996.8 1287.584) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.614 2c-7.509 0-14.792 1.47-21.647 4.37a55.532 55.532 0 0 0-9.446 5.127 56.05 56.05 0 0 0-8.232 6.792 56.05 56.05 0 0 0-6.792 8.232 55.532 55.532 0 0 0-5.127 9.446C3.47 42.822 2 50.105 2 57.614c0 7.508 1.47 14.791 4.37 21.646a55.532 55.532 0 0 0 5.127 9.446 56.059 56.059 0 0 0 6.792 8.233 55.673 55.673 0 0 0 17.678 11.919c6.855 2.899 14.138 4.369 21.647 4.369 7.509 0 14.792-1.47 21.647-4.369a55.673 55.673 0 0 0 17.678-11.919 55.673 55.673 0 0 0 11.919-17.679c2.899-6.855 4.37-14.138 4.37-21.646 0-7.509-1.471-14.792-4.37-21.647a55.673 55.673 0 0 0-11.919-17.678 56.05 56.05 0 0 0-8.232-6.792 55.532 55.532 0 0 0-9.446-5.127C72.406 3.47 65.123 2 57.614 2m0-2c31.819 0 57.614 25.795 57.614 57.614 0 31.819-25.795 57.613-57.614 57.613C25.795 115.227 0 89.433 0 57.614S25.795 0 57.614 0Z",
    style: {
      fill: "#747683",
      fillRule: "nonzero"
    },
    transform: "translate(996.8 1287.584) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1064.05 1354.834) scale(5.55556)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.509 0c24.965.001 45.507 20.543 45.507 45.508 0 24.965-20.543 45.508-45.508 45.508C20.543 91.016 0 70.473 0 45.508 0 20.543 20.543 0 45.508 0h.001Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.626 7.98)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.527,
    cy: 18.527,
    r: 18.527,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.527,
    cy: 18.527,
    r: 17.777,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.764 14v41.458c0 7.727-6.273 14-14 14H14c-7.727 0-14-6.273-14-14V14C0 6.273 6.273 0 14 0h21.764c7.727 0 14 6.273 14 14Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(20.626 50.544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.014 14v41.458c0 7.313-5.937 13.25-13.25 13.25H14c-7.313 0-13.25-5.937-13.25-13.25V14C.75 6.687 6.687.75 14 .75h21.764c7.313 0 13.25 5.937 13.25 13.25Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(20.626 50.544)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1078.279 518.073) scale(5.55556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.137,
    cy: 43.137,
    r: 43.137,
    style: {
      fill: "#25a9ef"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.137,
    cy: 43.137,
    r: 42.137,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2,
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1128.634 568.428) scale(5.55556)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.073,
    cy: 34.073,
    r: 34.073
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.684 5.975)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.872,
    cy: 13.872,
    r: 13.872,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.872,
    cy: 13.872,
    r: 13.122,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.259 14v24.005c0 7.727-6.273 14-14 14H14c-7.727 0-14-6.273-14-14V14C0 6.273 6.273 0 14 0h9.259c7.727 0 14 6.273 14 14Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(15.443 37.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.509 14v24.005c0 7.313-5.937 13.25-13.25 13.25H14c-7.313 0-13.25-5.937-13.25-13.25V14C.75 6.687 6.687.75 14 .75h9.259c7.313 0 13.25 5.937 13.25 13.25Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(15.443 37.844)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1755.346 518.073) scale(5.55556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.137,
    cy: 43.137,
    r: 43.137,
    style: {
      fill: "#fec633"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.137,
    cy: 43.137,
    r: 42.137,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2,
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1805.701 568.428) scale(5.55556)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.073,
    cy: 34.073,
    r: 34.073
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.684 5.975)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.872,
    cy: 13.872,
    r: 13.872,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.872,
    cy: 13.872,
    r: 13.122,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.259 14v24.005c0 7.727-6.273 14-14 14H14c-7.727 0-14-6.273-14-14V14C0 6.273 6.273 0 14 0h9.259c7.727 0 14 6.273 14 14Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(15.443 37.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.509 14v24.005c0 7.313-5.937 13.25-13.25 13.25H14c-7.313 0-13.25-5.937-13.25-13.25V14C.75 6.687 6.687.75 14 .75h9.259c7.313 0 13.25 5.937 13.25 13.25Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(15.443 37.844)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(716.24 29.078) scale(5.55556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.137,
    cy: 43.137,
    r: 43.137,
    style: {
      fill: "#fec633"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.137,
    cy: 43.137,
    r: 42.137,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2,
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(766.595 79.433) scale(5.55556)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.073,
    cy: 34.073,
    r: 34.073
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.684 5.975)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.872,
    cy: 13.872,
    r: 13.872,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.872,
    cy: 13.872,
    r: 13.122,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.259 14v24.005c0 7.727-6.273 14-14 14H14c-7.727 0-14-6.273-14-14V14C0 6.273 6.273 0 14 0h9.259c7.727 0 14 6.273 14 14Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(15.443 37.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.509 14v24.005c0 7.313-5.937 13.25-13.25 13.25H14c-7.313 0-13.25-5.937-13.25-13.25V14C.75 6.687 6.687.75 14 .75h9.259c7.313 0 13.25 5.937 13.25 13.25Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(15.443 37.844)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(493.434 575.467) scale(5.55556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.806,
    cy: 32.806,
    r: 32.806,
    style: {
      fill: "#f27931"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.806,
    cy: 32.806,
    r: 31.806,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2,
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(531.728 613.762) scale(5.55556)"
  }, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.913,
    cy: 25.913,
    r: 25.913
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.731 4.544)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.55,
    cy: 10.549,
    rx: 10.55,
    ry: 10.549,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.55,
    cy: 10.549,
    rx: 9.8,
    ry: 9.799,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.336 14v11.55c0 7.727-6.273 14-14 14H14c-7.727 0-14-6.273-14-14V14C0 6.273 6.273 0 14 0h.336c7.727 0 14 6.273 14 14Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(11.745 28.781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.586 14v11.55c0 7.313-5.937 13.25-13.25 13.25H14C6.687 38.8.75 32.863.75 25.55V14C.75 6.687 6.687.75 14 .75h.336c7.313 0 13.25 5.937 13.25 13.25Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(11.745 28.781)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M32.806 64.612a31.692 31.692 0 0 1-22.49-9.316A31.692 31.692 0 0 1 1 32.806a31.692 31.692 0 0 1 9.316-22.49A31.692 31.692 0 0 1 32.806 1a31.692 31.692 0 0 1 22.49 9.316 31.692 31.692 0 0 1 9.316 22.49 31.692 31.692 0 0 1-9.316 22.49 31.692 31.692 0 0 1-22.49 9.316Z",
    style: {
      fill: "#25a9ef",
      fillRule: "nonzero"
    },
    transform: "translate(0 575.467) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.806 2a30.706 30.706 0 0 0-21.783 9.023A30.706 30.706 0 0 0 2 32.806a30.706 30.706 0 0 0 9.023 21.783 30.706 30.706 0 0 0 21.783 9.023 30.712 30.712 0 0 0 21.783-9.023 30.69 30.69 0 0 0 6.603-9.793 30.603 30.603 0 0 0 2.42-11.99c0-4.16-.814-8.194-2.42-11.99a30.69 30.69 0 0 0-6.603-9.793A30.712 30.712 0 0 0 32.806 2m0-2c18.118 0 32.806 14.688 32.806 32.806 0 18.118-14.688 32.806-32.806 32.806C14.688 65.612 0 50.924 0 32.806 0 14.688 14.688 0 32.806 0Z",
    style: {
      fill: "#747683",
      fillRule: "nonzero"
    },
    transform: "translate(0 575.467) scale(5.55556)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.294 613.762) scale(5.55556)"
  }, _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.913,
    cy: 25.913,
    r: 25.913
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.731 4.544)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.55,
    cy: 10.549,
    rx: 10.55,
    ry: 10.549,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.55,
    cy: 10.549,
    rx: 9.8,
    ry: 9.799,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.336 14v11.55c0 7.727-6.273 14-14 14H14c-7.727 0-14-6.273-14-14V14C0 6.273 6.273 0 14 0h.336c7.727 0 14 6.273 14 14Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(11.745 28.781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.586 14v11.55c0 7.313-5.937 13.25-13.25 13.25H14C6.687 38.8.75 32.863.75 25.55V14C.75 6.687 6.687.75 14 .75h.336c7.313 0 13.25 5.937 13.25 13.25Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(11.745 28.781)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1096.718) scale(5.55556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.806,
    cy: 32.806,
    r: 32.806,
    style: {
      fill: "#fec633"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.806,
    cy: 32.806,
    r: 31.806,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2,
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.294 1135.012) scale(5.55556)"
  }, _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.913,
    cy: 25.913,
    r: 25.913
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.731 4.544)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.55,
    cy: 10.549,
    rx: 10.55,
    ry: 10.549,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.55,
    cy: 10.549,
    rx: 9.8,
    ry: 9.799,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.336 14v11.55c0 7.727-6.273 14-14 14H14c-7.727 0-14-6.273-14-14V14C0 6.273 6.273 0 14 0h.336c7.727 0 14 6.273 14 14Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(11.745 28.781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.586 14v11.55c0 7.313-5.937 13.25-13.25 13.25H14C6.687 38.8.75 32.863.75 25.55V14C.75 6.687 6.687.75 14 .75h.336c7.313 0 13.25 5.937 13.25 13.25Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(11.745 28.781)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(465.461 1410.829) scale(5.55556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.429,
    cy: 35.429,
    r: 35.429,
    style: {
      fill: "#25a9ef"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.429,
    cy: 35.429,
    r: 34.429,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2,
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(506.817 1452.184) scale(5.55556)"
  }, _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.985,
    cy: 27.985,
    r: 27.985
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.988 4.907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.393,
    cy: 11.393,
    r: 11.393,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.393,
    cy: 11.393,
    r: 10.643,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.602 14v14.713c0 7.727-6.273 14-14 14H14c-7.727 0-14-6.273-14-14V14C0 6.273 6.273 0 14 0h2.602c7.727 0 14 6.273 14 14Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(12.684 31.082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.852 14v14.713c0 7.313-5.937 13.25-13.25 13.25H14c-7.313 0-13.25-5.937-13.25-13.25V14C.75 6.687 6.687.75 14 .75h2.602c7.313 0 13.25 5.937 13.25 13.25Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(12.684 31.082)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1774.64 1381.607) scale(5.55556)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.429,
    cy: 35.429,
    r: 35.429,
    style: {
      fill: "#f27931"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.429,
    cy: 35.429,
    r: 34.429,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: 2,
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1815.996 1422.962) scale(5.55556)"
  }, _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.985,
    cy: 27.985,
    r: 27.985
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.988 4.907)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.393,
    cy: 11.393,
    r: 11.393,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.393,
    cy: 11.393,
    r: 10.643,
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.602 14v14.713c0 7.727-6.273 14-14 14H14c-7.727 0-14-6.273-14-14V14C0 6.273 6.273 0 14 0h2.602c7.727 0 14 6.273 14 14Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(12.684 31.082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.852 14v14.713c0 7.313-5.937 13.25-13.25 13.25H14c-7.313 0-13.25-5.937-13.25-13.25V14C.75 6.687 6.687.75 14 .75h2.602c7.313 0 13.25 5.937 13.25 13.25Z",
    style: {
      fill: "none",
      stroke: "#747683",
      strokeWidth: "1.5px",
      strokeLinecap: "butt"
    },
    transform: "translate(12.684 31.082)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyTreeDnaa);
export default __webpack_public_path__ + "static/media/family-tree-dnaa.8fda33a0bdd7c1553299fd257959874f.svg";
export { ForwardRef as ReactComponent };